var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('RiveGame',{attrs:{"src":"/animations/vacaciones.riv","fit":"contain","alignment":"center"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }